// removed by extract-text-webpack-plugin
module.exports = {"rwd-table":"rwd-table_1RTe5","refund":"refund_2uxvd"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/component/bill_full/style.css
 ** module id = 931
 ** module chunks = 0
 **/